/**
 * url 查詢引數解析工具。
 *
 * history 與 hash 兩種路由模式都會覆蓋：查詢串可能出現在 `?` 之後，
 * 也可能出現在 `#` 之後（例如 `#/page?token=xxx`）。
 */

/** 解析 `a=1&b=2` 形式的查詢串，返回普通物件 */
export function parseQueryString(queryString) {
  const query = {};
  if (!queryString) {
    return query;
  }
  queryString.split('&').forEach((pair) => {
    if (!pair) {
      return;
    }
    const separatorIndex = pair.indexOf('=');
    const key = separatorIndex === -1 ? pair : pair.slice(0, separatorIndex);
    const value = separatorIndex === -1 ? '' : pair.slice(separatorIndex + 1);
    if (!key) {
      return;
    }
    try {
      query[decodeURIComponent(key)] = decodeURIComponent(value);
    } catch (e) {
      query[key] = value;
    }
  });
  return query;
}

/** 取出 url 中 search 與 hash 兩部分的查詢串（history / hash 路由都能覆蓋） */
export function extractQueryString(url) {
  const hashIndex = url.indexOf('#');
  const beforeHash = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : url.slice(hashIndex + 1);
  const parts = [];

  [beforeHash, hash].forEach((part) => {
    const queryIndex = part.indexOf('?');
    if (queryIndex !== -1) {
      parts.push(part.slice(queryIndex + 1));
    }
  });

  return parts.join('&');
}

/**
 * 從 url 上按 keys 的優先順序取出引數值
 * @param {String} [url] 目標 url，預設取當前位址欄
 * @param {Array<String>} keys 引數名，按優先順序排列
 * @returns {String} 取不到時返回空字串
 */
export function getUrlParamFromUrl(url, keys) {
  let target = url;
  if (!target && typeof window !== 'undefined' && window.location) {
    target = window.location.href;
  }
  if (!target) {
    return '';
  }

  const query = parseQueryString(extractQueryString(target));
  const names = keys || [];
  for (let i = 0; i < names.length; i++) {
    const value = query[names[i]];
    if (value) {
      return value;
    }
  }
  return '';
}
